<template>
  <c-select
    v-model="type"
    title="ТИП ОТЧЕТА:"
    form-group
    form-group-margin-bottom
    :options="{ days: 'ПО ДНЯМ', updates: 'ПО АПДЕЙТАМ' }"
  />
</template>

<script>
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import { mapActions } from 'vuex'

/**
 * Select для выбора типа отчета по позициям (по апдейтам, по дням).
 */
export default {
  name: 'PositionsTypeSelect',
  components: {
    CSelect
  },
  computed: {
    /**
     * Тип отчета по позициям.
     */
    type: {
      get () {
        return this.$store.state.seo.positionsFilter.type
      },
      set (value) {
        this.changeType(value)
      }
    }
  },
  methods: {
    ...mapActions({
      changeType: 'seo/positionsFilter/changeType'
    })
  }
}
</script>
